import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../services/api';
import Sidebar from '../components/Sidebar';
import Anexos from '../components/Anexos';
import ClienteContatos from '../components/ClienteContatos';

export default function Clientes() {
  const [clientes, setClientes] = useState([]);
  const [busca, setBusca] = useState('');
  const [form, setForm] = useState({ razao_social: '', cpf_cnpj: '', contato_nome: '', contato_telefone: '', contato_email: '', endereco: '', origem: '', indicacao: '', comissao_indicacao: '', observacoes: '' });
  const [editando, setEditando] = useState(null);
  const [mostrarForm, setMostrarForm] = useState(false);
  const [erro, setErro] = useState('');
  const navigate = useNavigate();

  useEffect(() => { carregar(); }, []);

  async function carregar() {
    const res = await api.get('/clientes/');
    setClientes(res.data);
  }

  function mascaraCnpj(valor) {
    return valor.replace(/\D/g, '').slice(0, 14)
      .replace(/^(\d{2})(\d)/, '$1.$2')
      .replace(/^(\d{2})\.(\d{3})(\d)/, '$1.$2.$3')
      .replace(/\.(\d{3})(\d)/, '.$1/$2')
      .replace(/(\d{4})(\d)/, '$1-$2');
  }

  function cnpjValido(valor) { return valor.replace(/\D/g, '').length === 14; }

  function formatarCnpj(valor) {
    if (!valor) return '';
    const nums = valor.replace(/\D/g, '');
    return nums.replace(/^(\d{2})(\d)/, '$1.$2')
      .replace(/^(\d{2})\.(\d{3})(\d)/, '$1.$2.$3')
      .replace(/\.(\d{3})(\d)/, '.$1/$2')
      .replace(/(\d{4})(\d)/, '$1-$2');
  }

  async function salvar() {
    setErro('');
    if (!cnpjValido(form.cpf_cnpj)) { setErro('CNPJ inválido! Use o formato XX.XXX.XXX/XXXX-XX'); return; }
    const dadosParaSalvar = {
      ...form,
      cpf_cnpj: form.cpf_cnpj.replace(/\D/g, ''),
      comissao_indicacao: form.comissao_indicacao === '' ? null : parseFloat(form.comissao_indicacao)
    };
    try {
      if (editando) {
        await api.put(`/clientes/${editando}`, dadosParaSalvar);
      } else {
        await api.post('/clientes/', dadosParaSalvar);
      }
      setForm({ razao_social: '', cpf_cnpj: '', contato_nome: '', contato_telefone: '', contato_email: '', endereco: '', origem: '', indicacao: '', comissao_indicacao: '', observacoes: '' });
      setEditando(null);
      setMostrarForm(false);
      carregar();
    } catch (err) {
      if (err.response?.status === 400) {
        setErro('Este CNPJ já está cadastrado.');
      } else {
        setErro('Erro ao salvar cliente.');
      }
    }
  }

  function editar(cliente) {
    setForm({ ...cliente, cpf_cnpj: formatarCnpj(cliente.cpf_cnpj), comissao_indicacao: cliente.comissao_indicacao != null ? String(cliente.comissao_indicacao) : '' });
    setEditando(cliente.id);
    setMostrarForm(true);
    setErro('');
  }

  async function desativar(id) {
    if (window.confirm('Desativar este cliente?')) {
      await api.delete(`/clientes/${id}`);
      carregar();
    }
  }

  const filtrados = clientes.filter(c =>
    c.razao_social.toLowerCase().includes(busca.toLowerCase()) ||
    c.cpf_cnpj.includes(busca.replace(/\D/g, ''))
  );

  return (
    <div style={styles.container}>
      <Sidebar />
      <div style={styles.conteudo}>
        <div style={styles.header}>
          <h1 style={styles.titulo}>Clientes</h1>
          <button style={styles.botaoNovo} onClick={() => { setMostrarForm(true); setEditando(null); setErro(''); setForm({ razao_social: '', cpf_cnpj: '', contato_nome: '', contato_telefone: '', contato_email: '', endereco: '', origem: '', indicacao: '', comissao_indicacao: '', observacoes: '' }); }}>
            + Novo Cliente
          </button>
        </div>

        <input style={styles.busca} placeholder="Buscar por nome ou CNPJ..." value={busca} onChange={e => setBusca(e.target.value)} />

        {mostrarForm && (
          <div style={styles.form}>
            <h3 style={styles.formTitulo}>{editando ? 'Editar Cliente' : 'Novo Cliente'}</h3>
            {erro && <p style={styles.erroMsg}>{erro}</p>}
            <div style={styles.grid}>
              <div style={styles.campo}>
                <label style={styles.label}>Razão Social *</label>
                <input style={styles.input} value={form.razao_social || ''} onChange={e => setForm({ ...form, razao_social: e.target.value })} />
              </div>
              <div style={styles.campo}>
                <label style={styles.label}>CNPJ *</label>
                <input style={styles.input} value={form.cpf_cnpj || ''} onChange={e => setForm({ ...form, cpf_cnpj: mascaraCnpj(e.target.value) })} placeholder="XX.XXX.XXX/XXXX-XX" maxLength={18} />
              </div>
              <div style={styles.campo}>
                <label style={styles.label}>Contato</label>
                <input style={styles.input} value={form.contato_nome || ''} onChange={e => setForm({ ...form, contato_nome: e.target.value })} />
              </div>
              <div style={styles.campo}>
                <label style={styles.label}>Telefone</label>
                <input style={styles.input} value={form.contato_telefone || ''} onChange={e => setForm({ ...form, contato_telefone: e.target.value })} />
              </div>
              <div style={styles.campo}>
                <label style={styles.label}>Email</label>
                <input style={styles.input} value={form.contato_email || ''} onChange={e => setForm({ ...form, contato_email: e.target.value })} />
              </div>
              <div style={styles.campo}>
                <label style={styles.label}>Endereço</label>
                <input style={styles.input} value={form.endereco || ''} onChange={e => setForm({ ...form, endereco: e.target.value })} />
              </div>
              <div style={styles.campo}>
                <label style={styles.label}>Origem</label>
                <input style={styles.input} value={form.origem || ''} onChange={e => setForm({ ...form, origem: e.target.value })} />
              </div>
              <div style={styles.campo}>
                <label style={styles.label}>Indicação</label>
                <input style={styles.input} value={form.indicacao || ''} onChange={e => setForm({ ...form, indicacao: e.target.value })} placeholder="Nome de quem indicou" />
              </div>
              <div style={styles.campo}>
                <label style={styles.label}>% Comissão Indicação</label>
                <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                  <input
                    style={{ ...styles.input, flex: 1 }}
                    type="number"
                    min="0"
                    max="100"
                    step="0.01"
                    value={form.comissao_indicacao}
                    onChange={e => {
                      const val = parseFloat(e.target.value);
                      if (e.target.value === '' || (val >= 0 && val <= 100)) {
                        setForm({ ...form, comissao_indicacao: e.target.value });
                      }
                    }}
                    placeholder="Ex: 5.00"
                  />
                  <span style={{ fontSize: '14px', color: '#555' }}>%</span>
                </div>
              </div>
              <div style={styles.campo}>
                <label style={styles.label}>Observações</label>
                <textarea style={{ ...styles.input, height: '70px' }} value={form.observacoes || ''} onChange={e => setForm({ ...form, observacoes: e.target.value })} />
              </div>
            </div>
            {editando && (
              <Anexos clienteId={editando} atividadeId={null} />
            )}
            {editando && (
              <ClienteContatos clienteId={editando} />
            )}
            <div style={styles.formBotoes}>
              <button style={styles.botaoSalvar} onClick={salvar}>Salvar</button>
              <button style={styles.botaoCancelar} onClick={() => { setMostrarForm(false); setErro(''); }}>Cancelar</button>
            </div>
          </div>
        )}

        <table style={styles.tabela}>
          <thead>
            <tr>
              {['Razão Social', 'CNPJ', 'Contato', 'Telefone', 'Origem', 'Indicação', '% Comissão', 'Ações'].map(h => (
                <th key={h} style={styles.th}>{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {filtrados.map(c => (
              <tr key={c.id} style={styles.tr}>
                <td style={styles.td}>{c.razao_social}</td>
                <td style={styles.td}>{formatarCnpj(c.cpf_cnpj)}</td>
                <td style={styles.td}>{c.contato_nome || '-'}</td>
                <td style={styles.td}>{c.contato_telefone || '-'}</td>
                <td style={styles.td}>{c.origem || '-'}</td>
                <td style={styles.td}>{c.indicacao || '-'}</td>
                <td style={styles.td}>{c.comissao_indicacao != null ? `${c.comissao_indicacao}%` : '-'}</td>
                <td style={styles.td}>
                  <button style={styles.botaoEditar} onClick={() => editar(c)}>Editar</button>
                  <button style={styles.botaoDesativar} onClick={() => desativar(c.id)}>Desativar</button>
                  <button style={styles.botaoPasta} onClick={() => navigate(`/clientes/${c.id}/pasta`)}>📁 Pasta</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

const styles = {
  container: { display: 'flex', height: '100vh', overflow: 'hidden', backgroundColor: '#f0f2f5' },
  conteudo: { flex: 1, padding: '2.5rem', overflowY: 'auto' },
  header: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1.5rem' },
  titulo: { fontSize: '22px', color: '#1a1a2e', margin: 0 },
  botaoNovo: { backgroundColor: '#1a1a2e', color: '#fff', border: 'none', padding: '10px 18px', borderRadius: '6px', fontSize: '14px', cursor: 'pointer' },
  busca: { width: '100%', padding: '10px 12px', borderRadius: '6px', border: '1px solid #ddd', fontSize: '14px', marginBottom: '1.5rem', boxSizing: 'border-box' },
  form: { backgroundColor: '#fff', padding: '1.5rem', borderRadius: '8px', marginBottom: '1.5rem', border: '1px solid #e0e0e0' },
  formTitulo: { margin: '0 0 1rem', fontSize: '16px', color: '#1a1a2e' },
  erroMsg: { color: '#e53935', fontSize: '13px', marginBottom: '1rem', backgroundColor: '#ffebee', padding: '8px 12px', borderRadius: '6px' },
  grid: { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px' },
  campo: { display: 'flex', flexDirection: 'column' },
  label: { fontSize: '12px', color: '#555', marginBottom: '4px' },
  input: { padding: '9px 12px', borderRadius: '6px', border: '1px solid #ddd', fontSize: '14px' },
  formBotoes: { display: 'flex', gap: '10px', marginTop: '1rem' },
  botaoSalvar: { backgroundColor: '#1a1a2e', color: '#fff', border: 'none', padding: '10px 20px', borderRadius: '6px', fontSize: '14px', cursor: 'pointer' },
  botaoCancelar: { backgroundColor: 'transparent', color: '#888', border: '1px solid #ddd', padding: '10px 20px', borderRadius: '6px', fontSize: '14px', cursor: 'pointer' },
  tabela: { width: '100%', borderCollapse: 'collapse', backgroundColor: '#fff', borderRadius: '8px', overflow: 'hidden' },
  th: { padding: '12px 16px', textAlign: 'left', fontSize: '12px', color: '#888', borderBottom: '1px solid #f0f0f0', fontWeight: '500' },
  tr: { borderBottom: '1px solid #f0f0f0' },
  td: { padding: '12px 16px', fontSize: '14px', color: '#333' },
  botaoEditar: { backgroundColor: 'transparent', color: '#1a1a2e', border: '1px solid #ddd', padding: '5px 12px', borderRadius: '4px', fontSize: '12px', cursor: 'pointer', marginRight: '6px' },
  botaoDesativar: { backgroundColor: 'transparent', color: '#e53935', border: '1px solid #e53935', padding: '5px 12px', borderRadius: '4px', fontSize: '12px', cursor: 'pointer' },
  botaoPasta: { backgroundColor: 'transparent', color: '#f57c00', border: '1px solid #f57c00', padding: '5px 12px', borderRadius: '4px', fontSize: '12px', cursor: 'pointer', marginLeft: '6px' },
};